import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import { isRedoEmailAddress } from "@redotech/redo-model/redo-domains";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { RedoPlatformAuthRpcClientContext } from "./platform/redo-platform-rpc-client-provider";
import { TeamContext } from "./team";
import { UserContext } from "./user";

export interface IntelligentCycleCountsFlagState {
  readonly pending: boolean;
  readonly enabled: boolean;
}

export function useIntelligentCycleCountsFlag(): IntelligentCycleCountsFlagState {
  const user = useContext(UserContext);
  const team = useRequiredContext(TeamContext);
  const platformRpcClient = useRequiredContext(
    RedoPlatformAuthRpcClientContext,
  );

  const isRedoEmail = isRedoEmailAddress(user?.email);

  const query = useQuery({
    queryKey: [
      "featureFlag",
      FeatureFlagKey.INTELLIGENT_CYCLE_COUNTS,
      String(team._id),
    ],
    queryFn: async () => {
      const response = await platformRpcClient.getFeatureFlag({
        flagKey: FeatureFlagKey.INTELLIGENT_CYCLE_COUNTS,
      });
      return response.enabled;
    },
    enabled: !isRedoEmail,
    staleTime: Infinity,
  });

  return {
    pending: !isRedoEmail && query.isPending,
    enabled: isRedoEmail || (query.data ?? false),
  };
}
